import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase/db";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

type Props = { onSwitch: (page: "register" | "login") => void };

const RegisterPage: React.FC<Props> = ({ onSwitch }) => {
  const { register } = useAuth();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const cred = await register(email, password, username);

      if (cred && cred.user) {
        await setDoc(doc(db, "users", cred.user.uid), {
          email,
          username,
          createdAt: new Date(),
        });
      }

      navigate("/inventory", { replace: true }); // Navigate to inventory page on successful registration
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <form
      onSubmit={handleRegister}
      className="flex flex-col gap-4 bg-white rounded-xl shadow-md p-8 w-full max-w-md mx-auto"
    >
      <h2 className="text-xl font-semibold text-center">Register</h2>
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded relative text-center">
          {error}
        </div>
      )}
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        className="input input-bordered w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
      />
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={e => setUsername(e.target.value)}
        required
        className="input input-bordered w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        required
        className="input input-bordered w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
      />
      <input
        type="password"
        placeholder="Confirm Password"
        value={confirmPassword}
        onChange={e => setConfirmPassword(e.target.value)}
        required
        className="input input-bordered w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
      />
      <button
        type="submit"
        className="bg-indigo-500 text-white py-2 rounded hover:bg-indigo-600 transition"
      >
        Register
      </button>
      <button
        type="button"
        className="text-indigo-500 hover:underline text-sm"
        onClick={() => onSwitch("login")}
      >
        Back to Login
      </button>
    </form>
  );
};

export default RegisterPage;